module.exports = __webpack_public_path__ + "img/project4.214a583a.png";